import React from 'react';
import PropTypes from 'prop-types';

export default function ContributorLike({
  contributorName,
  contributorProfilePicture,
}) {
  return (
    <div className="contributor-like">
      <img className="contributor-image" src={`${contributorProfilePicture}`} alt={`${contributorName} liked this comment`} />
      <span className="icon-lw icon-lw-contributor-liked">
        <span className="path1" />
        <span className="path2" />
      </span>
    </div>
  );
}

ContributorLike.propTypes = {
  contributorName: PropTypes.string.isRequired,
  contributorProfilePicture: PropTypes.string.isRequired,
};
